import React from 'react';
import './FirstSlider.css';
import SW1 from '../../Assets/sw1.png';
import SW2 from '../../Assets/sw2.png';
import SW3 from '../../Assets/sw3.png';
import SW4 from '../../Assets/sw4.png';
import SW5 from '../../Assets/sw5.png';
import SW6 from '../../Assets/sw6.png';
import SW7 from '../../Assets/sw7.png';


function FirstSlider() {
  return (
    <div className='First_Slider'>
      <div className='First_Slider_Head'>
        <h1>AFFILIATIONS</h1>
        <h6>National & International</h6>
        <hr />
        <div className='First_Slider_Main'>
          <marquee scrollamount='5' direction="left">
            <img src={SW1} alt="" />
            <img src={SW2} alt="" />
            <img src={SW3} alt="" />
            <img src={SW4} alt="" />
            <img src={SW5} alt="" />
            <img src={SW6} alt="" />
            <img src={SW7} alt="" />
          </marquee>
        </div>
      </div>
    </div> 
  )
}

export default FirstSlider
